module.exports = __webpack_public_path__ + "img/plan-grey.90fd7f87.svg";